module.exports = __webpack_public_path__ + "static/assets/d505a716f1a00276ab72af1b4d0ec190.gif";